{
  "fetchedAt": "2026-10-22T20:21:50.651Z",
  "entries": {
    "rars": {
      "stars": 1667,
      "forks": 315,
      "openIssues": 78,
      "contributors": 25,
      "lastPush": "2024-07-19T16:46:44Z",
      "latestRelease": {
        "tag": "v1.6",
        "date": "2023-02-27T06:16:43Z",
        "assets": 1
      }
    },
    "ripes": {
      "stars": 3455,
      "forks": 384,
      "openIssues": 86,
      "contributors": 41,
      "lastPush": "2026-10-22T07:35:19Z",
      "latestRelease": {
        "tag": "v2.3.0",
        "date": "2026-10-19T19:37:22Z",
        "assets": 3
      }
    },
    "venus": {
      "stars": 240,
      "forks": 69,
      "openIssues": 15,
      "contributors": 4,
      "lastPush": "2022-04-02T22:04:36Z",
      "latestRelease": {
        "tag": "v0.1.1",
        "date": "2017-09-16T05:33:22Z",
        "assets": 0
      }
    },
    "spike": {
      "stars": 3261,
      "forks": 1134,
      "openIssues": 403,
      "contributors": 241,
      "lastPush": "2026-10-22T06:50:22Z",
      "latestRelease": {
        "tag": "v1.1.0",
        "date": "2021-12-17T09:12:58Z",
        "assets": 0
      }
    },
    "rocket": {
      "stars": 3891,
      "forks": 1308,
      "openIssues": 359,
      "contributors": 189,
      "lastPush": "2026-09-13T01:04:13Z",
      "latestRelease": {
        "tag": "v1.6",
        "date": "2022-10-10T12:40:41Z",
        "assets": 0
      }
    },
    "ibex": {
      "stars": 2127,
      "forks": 825,
      "openIssues": 274,
      "contributors": 119,
      "lastPush": "2026-10-21T14:22:07Z",
      "latestRelease": null
    },
    "boom": {
      "stars": 2265,
      "forks": 533,
      "openIssues": 188,
      "contributors": 51,
      "lastPush": "2026-10-08T21:48:20Z",
      "latestRelease": {
        "tag": "v3.0.0",
        "date": "2020-06-01T06:43:14Z",
        "assets": 0
      }
    },
    "xiangshan": {
      "stars": 7332,
      "forks": 964,
      "openIssues": 337,
      "contributors": 145,
      "lastPush": "2026-10-22T13:00:50Z",
      "latestRelease": null
    },
    "picorv32": {
      "stars": 4392,
      "forks": 1028,
      "openIssues": 86,
      "contributors": 39,
      "lastPush": "2026-09-07T08:01:26Z",
      "latestRelease": {
        "tag": "v1.0",
        "date": "2019-03-02T22:36:17Z",
        "assets": 0
      }
    },
    "vexriscv": {
      "stars": 3296,
      "forks": 519,
      "openIssues": 145,
      "contributors": 57,
      "lastPush": "2026-10-13T06:45:57Z",
      "latestRelease": null
    }
  }
}
